import { render, staticRenderFns } from "./LineaTiempoA.vue?vue&type=template&id=60ddd095&scoped=true&lang=pug&"
import script from "./LineaTiempoA.vue?vue&type=script&lang=js&"
export * from "./LineaTiempoA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddd095",
  null
  
)

export default component.exports